// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileBroadcastPortraitUI{position:absolute;height:100%;width:100vmin;top:0;left:50%;transform:translateX(-50%)}.MobileBroadcastPortraitUI__statusContainer{margin:8px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
